import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Modal,
  Container,
} from "reactstrap"

const ModalComponent = ({
  open,
  onClose,
  children,
  title,
  size,
  style,
  scrollable = false,
  returnFocusAfterClose = true,
}) => {
  return (
    <Modal
      isOpen={open}
      toggle={onClose}
      centered={true}
      size={size}
      style={style}
      scrollable={scrollable}
      returnFocusAfterClose={returnFocusAfterClose}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0">{title}</h5>
        <button
          type="button"
          onClick={onClose}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">{children}</div>
    </Modal>
  )
}
export default ModalComponent
